module.exports = __webpack_public_path__ + "img/appBarLogo.22252e12.png";